export default __webpack_public_path__ + "static/media/yenta.0df5b1a3.png";